module.exports = __webpack_public_path__ + "sunsemweb/img/bg.58e87866.png";